import { Route, Switch } from 'react-router';

import { ToxnotReactComponentPaths } from '../core/ToxnotReactComponentPaths';
import StaticPageReloader from '../StaticPageReloader';
import NewsDetail from './NewsDetail';
import NewsHome from './NewsHome';
import NewsSearch from './NewsSearch';

// ==============================================================================

export default () => {
    return (
        <Switch>
            <Route exact={true} path={ToxnotReactComponentPaths.BaseNewsLandingPath} component={NewsHome} />
            <Route exact={true} path={ToxnotReactComponentPaths.BaseNewsArticlePath} component={NewsDetail} />
            <Route exact={true} path={ToxnotReactComponentPaths.BaseNewsSearchPath} component={NewsSearch} />
            <Route component={StaticPageReloader} />
        </Switch>
    );
}